import { getAppConfig } from '@bts-web/core-app-config';
import { AppUserFullInfo } from '../../userinfo/types';

export const isDac8FeatureEnabled = (): boolean => {
  const { disableDac8 = false } = getAppConfig();

  return !disableDac8;
};

export const checkDac8Enabled = (
  userData: Pick<AppUserFullInfo, 'tradingActive' | 'taxCompliant'>,
): boolean => {
  const { tradingActive, taxCompliant } = userData;

  return isDac8FeatureEnabled() && tradingActive === false && !taxCompliant;
};
